import React from 'react';
import { CSSTransition } from 'react-transition-group';

import PageLayout from 'layouts/PageLayout';
import Sidebar from 'scenes/Sidebar';
import InBoundsHistory from 'scenes/Sidebar/components/InBoundsHistory';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog';
import FiltersAccordion from 'scenes/FiltersAccordion';
import FiltersForm from 'scenes/FiltersAccordion/components/FiltersForm';
import { ANIMATION_TIMEOUT_APPEAR } from 'constants/animation.js';

import { useCollectionFilters } from 'hooks/useCollectionFilters';
import { ENDPOINT } from 'constants/endpoints';
import { useApi } from 'hooks/useApi';
import { PERMISSIONS } from 'constants/permissions';

import './styles.css';

const InBoundsRequirements = props => {
  const {
    user: {
      permissions: { [PERMISSIONS.MANAGE_INBOUNDS_REQUIREMENTS]: enable },
    },
    location: { pathname },
    history,
  } = props;

  const api = useApi();

  const [
    { sections: filters, query },
    { clear, change, groupClear, groupSelect, push, search: filterSearch },
  ] = useCollectionFilters(ENDPOINT.FILTERS.INBOUNDS_REQUIREMENTS);

  const saveFiltersFormHandler = () => {
    if (enable) {
      api.post(ENDPOINT.FILTERS.INBOUNDS_REQUIREMENTS, query, {
        handleError: response => ResponseErrorDialog({ response }),
        handleSuccess: () =>
          history.push(`${pathname.replace('/requirements', '')}`),
      });
    }
  };

  const subTitle = enable ? (
    'Use the filters below to place restrictions on who can send your firm an InBound.'
  ) : (
    <span style={{ color: '#ff0000' }}>
      Currently, you don't have permission to manage InBound Requirements.
    </span>
  );

  return (
    <PageLayout
      pageClass="inbound-requirements"
      pageTitle="Inbounds Requirements"
      mainContent={
        <CSSTransition
          in={true}
          appear={true}
          timeout={ANIMATION_TIMEOUT_APPEAR}
          classNames="fade"
        >
          <FiltersAccordion
            disabled={!enable}
            title="InBound Requirements"
            subTitle={subTitle}
            filters={filters}
            isFetching={false}
            onChange={change}
            onGroupSelectAll={groupSelect}
            onGroupClearAll={groupClear}
            onClearAll={clear}
            onSearch={filterSearch}
            onPushValue={push}
            onSaveForm={saveFiltersFormHandler}
            render={renderProps => <FiltersForm {...renderProps} />}
          />
        </CSSTransition>
      }
      sidebarContent={
        <CSSTransition
          in={true}
          appear={true}
          timeout={ANIMATION_TIMEOUT_APPEAR}
          classNames="fade"
        >
          <Sidebar>
            <InBoundsHistory isRecruiter />
          </Sidebar>
        </CSSTransition>
      }
    />
  );
};

export default InBoundsRequirements;
